import styled, { css } from 'styled-components'
import { themeFontWeight, FontWeightSBSansText, themeColor, themeFontFamily } from 'LibNeo'

export enum HeadingType {
	h1 = 'h1',
	h2 = 'h2',
	h3 = 'h3',
	h4 = 'h4',
	h5 = 'h5',
	h6 = 'h6',
	subtitle1 = 'subtitle1',
	subtitle2 = 'subtitle2',
}

const variants: Record<
	`${HeadingType}`,
	{
		fontSize: string
		fontWeight: FontWeightSBSansText
		lineHeight: string
		as: string
	}
> = {
	h1: {
		fontSize: '56px',
		fontWeight: 'regular',
		lineHeight: '64px',
		as: 'h1',
	},
	h2: {
		fontSize: '48px',
		fontWeight: 'regular',
		lineHeight: '56px',
		as: 'h2',
	},
	h3: {
		fontSize: '36px',
		fontWeight: 'regular',
		lineHeight: '48px',
		as: 'h3',
	},
	h4: {
		fontSize: '28px',
		fontWeight: 'regular',
		lineHeight: '32px',
		as: 'h4',
	},
	h5: {
		fontSize: '20px',
		fontWeight: 'medium',
		lineHeight: '32px',
		as: 'h5',
	},
	h6: {
		fontSize: '16px',
		fontWeight: 'medium',
		lineHeight: '20px',
		as: 'h6',
	},
	subtitle1: {
		fontSize: '16px',
		fontWeight: 'regular',
		lineHeight: '28px',
		as: 'div',
	},
	subtitle2: {
		fontSize: '14px',
		fontWeight: 'medium',
		lineHeight: '22px',
		as: 'div',
	},
}

export type HeadingProps = { type: `${HeadingType}`; transform?: 'uppercase' | 'lowercase' }

export const Heading = styled.div.attrs<HeadingProps>(({ type }) => ({
	as: variants[type].as,
}))<HeadingProps>`
	font-size: ${({ type }) => variants[type]?.fontSize};
	font-weight: ${({ type }) => themeFontWeight('SBSansText', variants[type]?.fontWeight)};
	line-height: ${({ type }) => variants[type]?.lineHeight};
	font-family: ${themeFontFamily('SBSansText')};
	color: ${themeColor('gray', 8)};
	padding: 0;
	margin: 0;
	${({ transform }) =>
		transform &&
		css`
			text-transform: ${transform};
		`}}
`
